/* Paris Medicos storefront event layer. Transmission remains owned by consent-aware Shopify pixels. */
(function () {
  'use strict';

  function emit(name, detail) {
    var payload = Object.assign({
      event: 'pm_' + name,
      page_type: document.querySelector('main')?.dataset.template || '',
      page_path: window.location.pathname
    }, detail || {});

    window.dispatchEvent(new CustomEvent('pm:analytics', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    var addButton = event.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]');

    if (addButton) {
      emit('add_to_cart_intent', { label: addButton.textContent.trim().slice(0, 80) });
      return;
    }
    if (!link) return;

    var url = new URL(link.href, window.location.origin);
    var detail = { destination: url.pathname, label: link.textContent.trim().slice(0, 100) };
    if (/\/products\//.test(url.pathname)) emit('select_product', detail);
    else if (/\/collections\//.test(url.pathname)) emit('select_collection', detail);
    else if (/wa\.me|whatsapp/i.test(link.href)) emit('whatsapp_click', detail);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('form[action*="/search"]')) emit('search', { search_term: form.querySelector('[name="q"]')?.value || '' });
    if (form.matches('form[action*="/contact"]')) emit('newsletter_submit');
  });

  emit('page_view');
})();
